import React from 'react';
import Card from 'react-bootstrap/Card';
import { CardText, FormGroup, InputGroup } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import MapLegendCustomized from "./MapLegendCustomized";
import DataNote from "./DataNote";

const cardStyle = {
    position: "absolute",
    top: "54px",
    margin: "1em",
    zIndex: 100,
    width:"400px",
}

const StartInfoCard = ({cutoffArr, setCutoffs, departureInfoQueryDate, setDepartureInfoQueryDate }) => {
    // handle user's input as they type, the cutoff state is updated with raw input to show user's input immediately
    const handleCutoffInput=(e)=>{
        const value = e.target.value.replace(',', '.'); // replace comma with dot for parsing
        const id = parseInt(e.target.id);
        const newCutoffArr = cutoffArr.map((e, idx) => idx === id ? value: e); // update the cutoff array with the new value
        setCutoffs(newCutoffArr);
    }
    // handle user's input when they leave the input field, the cutoff state is updated with parsed input as float
    const handleCutoffBlur = (e) => {
        const value = e.target.value.replace(',', '.'); // replace comma with dot for parsing
        const id = parseInt(e.target.id);
        const newCutoffArr = cutoffArr.map((cutoff, idx) => idx === id ? parseFloat(value) || 0 : cutoff); // update the cutoff array with the new value or 0 if the input is invalid
        setCutoffs(newCutoffArr);
    }
    // limit input to numbers and commas
    const handleKeyPress = (e) => {
        const value = e.target.value;
        const regex = /^[0-9,]*$/;
        if (!regex.test(value)) {
            e.preventDefault();
        }
    }
    return (
        <Card style={cardStyle}>
            <Card.Body>
                <Card.Title>Servus! </Card.Title>
                <Form.Label><b>Schritt 1: </b>Bitte definieren Sie die Grenzwerte des Servicebereichs.</Form.Label>
                <InputGroup className="mb-3">
                    {cutoffArr.map((e, idx) =>
                        <Form.Control
                            key={idx}
                            id={idx.toString()}
                            value={cutoffArr[idx].toString().replace('.', ',')}
                            aria-label={"radius_" + idx}
                            type="text"
                            onChange={handleCutoffInput}
                            onBlur={handleCutoffBlur} // format on blur
                            onBeforeInput={handleKeyPress} // limit input to numbers and commas
                            />)}
                    <InputGroup.Text>km</InputGroup.Text>
                </InputGroup>
                <FormGroup>
                    <Form.Label><b>Schritt 2: </b>Bitte definieren Sie das Datum für die Abfrage der Abfahrtsinformationen.</Form.Label>
                    <Form.Control
                        type="date"
                        value={departureInfoQueryDate}
                        onChange={(e)=>setDepartureInfoQueryDate(e.target.value)}
                        className="mb-3"
                    />
                </FormGroup>
                <Card.Text>
                    <b>Schritt 3:</b> Wählen Sie den Interessenspunkt aus, indem Sie auf die Karte klicken, um die Analyse zu starten.
                </Card.Text>
                <MapLegendCustomized />
                <CardText>
                    <DataNote />
                </CardText>
            </Card.Body>
            <Card.Footer>
                <img src="ispace_plus_logo_600dpi.png" alt="ispaceplus-logo" style={{ width: "35%", marginRight: "25px"}}/>
                <img src="Salzburg-Verkehr-Logo.png" alt="svv-logo" style={{ width: "43%" }}/>
            </Card.Footer>
        </Card>
    )
}

export default StartInfoCard;
